import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { ShiftDetailData } from '../api/types';

// Shift Detail side-panel data. Fetches only when a shift is selected
// (shiftId != null).
const useShiftDetail = (agencyId: number, shiftId: number | null) =>
  useQuery<ShiftDetailData>({
    queryKey: dashboardV2QueryKeys.shiftDetail(agencyId, shiftId ?? 0),
    queryFn: () =>
      dashboardV2Client.getShiftDetail(agencyId, shiftId as number),
    enabled: agencyId != null && shiftId != null,
    staleTime: 15_000,
  });

export default useShiftDetail;
